import React, {FC} from 'react'
import {Link} from 'react-router-dom'
import {KTIcon} from '../../../helpers'
import {Item1} from '../../content/jaguaru/Item1'
import {Item2} from '../../content/jaguaru/Item2'
import {Item3} from '../../content/jaguaru/Item3'
import {Item4} from '../../content/jaguaru/Item4'
import {Item5} from '../../content/jaguaru/Item5'
import {Item6} from '../../content/jaguaru/Item6'
import {Item7} from '../../content/jaguaru/Item7'
import {Item8} from '../../content/jaguaru/Item8'

const AdjuntoJaguaru: FC = () => (
  <div
    id='kt_activities5'
    className='bg-body'
    data-kt-drawer='true'
    data-kt-drawer-name='activities5'
    data-kt-drawer-activate='true'
    data-kt-drawer-overlay='true'
    data-kt-drawer-width="{default:'300px', 'lg': '900px'}"
    data-kt-drawer-direction='end'
    data-kt-drawer-toggle='#kt_activities_toggle5'
    data-kt-drawer-close='#kt_activities_close5'
  >
    <div className='card shadow-none rounded-0'>
      <div className='card-header' id='kt_activities_header5'>
        <h3 className='card-title fw-bolder text-dark'>Adjunto Jaguaru</h3>

        <div className='card-toolbar'>
          <button
            type='button'
            className='btn btn-sm btn-icon btn-active-light-primary me-n5'
            id='kt_activities_close5'
          >
            <KTIcon iconName='cross' className='fs-1' />
          </button>
        </div>
      </div>
      <div className='card-body position-relative' id='kt_activities_body5'>
        <div
          id='kt_activities_scroll5'
          className='position-relative scroll-y me-n5 pe-5'
          data-kt-scroll='true'
          data-kt-scroll-height='auto'
          data-kt-scroll-wrappers='#kt_activities_body5'
          data-kt-scroll-dependencies='#kt_activities_header5, #kt_activities_footer5'
          data-kt-scroll-offset='5px'
        >
          <div className='timeline'>
            <Item1 />
            <Item2 />
            <Item3 />
            <Item4 />
            <Item5 />
            <Item6 />
            <Item7 />
            <Item8 />
          </div>
        </div>
      </div>
      <div className='card-footer py-5 text-center' id='kt_activities_footer10'>
        <Link to='#' className='btn btn-bg-body text-primary'>
          Mais Sobre o Adjunto jaguaru
          <KTIcon iconName='arrow-right' className='fs-3 text-primary' />
        </Link>
      </div>
    </div>
  </div>
)

export {AdjuntoJaguaru}
